export { DetailsWidgetView } from './DetailsWidgetView';
